<template>
	<div class="options-selector clearfix">
		<div class="pa-block">
			<h3 class="selector-title">Options</h3>
			<div class="pa-block__inner pa-block__inner--flex">
				<div class="pa-block__main">
					<div
						v-if="classified.mode === 'print_web'"
						class="pa-block__row"
						:class="{
							active: option_background == '1',
							inactive: option_background != '1',
						}"
					>
						<input
							type="checkbox"
							:value="1"
							name="option_background"
							id="option_background"
							v-model="option_background"
							@change="updateOption"
						/>
						<label for="option_background">
							Fond de couleur
							<em
								><small
									>( {{ price("option_background") }} € TTC par
									{{ period() }})</small
								></em
							>
						</label>
					</div>
					<!-- .pa-block__row -->
					<div
						class="pa-block__row"
						:class="{
							active: option_urgent == '1',
							inactive: option_urgent != '1',
						}"
					>
						<input
							type="checkbox"
							:value="1"
							name="option_urgent"
							id="option_urgent"
							v-model="option_urgent"
							@change="updateOption"
						/>
						<label for="option_urgent">
							Logo "Urgent"
							<em
								><small
									>( {{ price("option_urgent") }} € TTC par
									{{ period() }})</small
								></em
							>
						</label>
					</div>
					<!-- .pa-block__row -->
					<div
						v-if="classified.mode == 'web'"
						class="pa-block__row"
						:class="{
							active: option_move_top == '1',
							inactive: option_move_top != '1',
						}"
					>
						<input
							type="checkbox"
							:value="1"
							name="option_move_top"
							id="option_move_top"
							v-model="option_move_top"
							@change="updateOption"
						/>
						<label for="option_move_top">
							Annonce à la une
							<span class="text-primary">NOUVEAU</span>
							<em
								><small>
									( {{ price("option_move_top") }} € TTC par {{ period() }})
								</small></em
							>
						</label>
					</div>
					<!-- .pa-block__row -->
					<div
						class="pa-block__row"
						v-if="
							classified.option_domiciliation &&
							classified.profil == 'proflib' &&
							classified.mode == 'print_web'
						"
						:class="{
							active: option_domiciliation == '1',
							inactive: option_domiciliation != '1',
						}"
					>
						<input
							type="checkbox"
							:value="1"
							name="option_domiciliation"
							id="option_domiciliation"
							v-model="option_domiciliation"
							@change="updateOption"
						/>
						<label
							for="option_domiciliation"
							v-if="
								classified.profil == 'proflib' && classified.mode == 'print_web'
							"
						>
							Domiciliation
							<em
								><small
									>( {{ price("option_urgent") }} € TTC par
									{{ period() }} )</small
								></em
							>
						</label>
					</div>
					<!-- .pa-block__row -->
					<div
						v-if="classified.profil === 'recruiter'"
						class="pa-block__row"
						:class="{
							active:
								classified.mode === 'print_web' || option_diff_abcdent == '1',
							inactive:
								classified.mode !== 'print_web' && option_diff_abcdent != '1',
						}"
					>
						<input
							type="checkbox"
							:value="'1'"
							name="option_diff_abcdent"
							id="option_diff_abcdent"
							v-model="option_diff_abcdent"
							@change="updateOption"
						/>
						<label for="option_diff_abcdent">
							Publication sur Abcdent.pro
							<span class="text-primary">
								{{
									classified.mode === "print_web" || isCurrentCategoryFree
										? "INCLUS"
										: "NOUVEAU"
								}}
							</span>
							<em
								v-if="classified.mode !== 'print_web' && !isCurrentCategoryFree"
								><small
									>( {{ price("option_diff_abcdent") }} € TTC par
									{{ period() }} )</small
								></em
							>
						</label>
					</div>
					<div
						v-if="classified.profil === 'proflib'"
						class="pa-block__row"
						:class="{
							active: option_diff_abcdent_pro == '1',
							inactive: option_diff_abcdent_pro != '1',
						}"
					>
						<input
							type="checkbox"
							:value="'1'"
							name="option_diff_abcdent_pro"
							id="option_diff_abcdent_pro"
							v-model="option_diff_abcdent_pro"
							@change="updateOption"
						/>
						<label for="option_diff_abcdent_pro">
							Publication sur Abcdent.pro
							<span class="text-primary">
								{{
									classified.mode === "print_web" || isCurrentCategoryFree
										? "INCLUS"
										: "NOUVEAU"
								}}
							</span>
							<em
								v-if="classified.mode !== 'print_web' && !isCurrentCategoryFree"
								><small
									>( {{ price("option_diff_abcdent_pro") }} € TTC par
									{{ period() }} )</small
								></em
							>
						</label>
					</div>
					<!-- .pa-block__row -->
				</div>
				<!-- pa-block__main -->
				<div
					class="pa-block__sidebar"
					v-if="
						classified.option_background ||
						classified.option_domiciliation ||
						classified.option_move_top ||
						classified.option_urgent ||
						classified.option_diff_abcdent ||
						classified.option_diff_abcdent_pro
					"
				>
					<fieldset>
						<legend>Prix total des options :</legend>
					</fieldset>
					<table>
						<tr>
							<td>
								<strong>
									Pour {{ parseInt(classified.duration) }}
									{{
										classified.mode == "web"
											? "mois"
											: "semaine" +
											  (parseInt(classified.duration) > 1 ? "s" : "")
									}}
								</strong>
							</td>
							<td>
								{{
									numberFormat(
										getPrice(classified, {
											only_options: true,
											no_medias: true,
											with_membership_discount: false,
											with_duration_discount: false,
											include_diff_abcdent:
												classified.mode !== "print_web" &&
												!isCurrentCategoryFree,
										})
									)
								}}
								€ <small>TTC</small>
							</td>
						</tr>
						<tr
							v-if="
								durationDiscount(
									parseInt(classified.duration),
									classified,
									true
								)
							"
						>
							<td>
								<strong>
									Remise (-{{
										durationDiscount(
											parseInt(classified.duration),
											classified,
											true
										)
									}}%)
								</strong>
							</td>
							<td>
								{{
									numberFormat(
										getPrice(classified, {
											only_options: true,
											no_medias: true,
											with_membership_discount: false,
											with_duration_discount: false,
											include_diff_abcdent:
												classified.mode === "print_web" &&
												isCurrentCategoryFree,
										}) -
											getPrice(classified, {
												only_options: true,
												no_medias: true,
												with_membership_discount: false,
												include_diff_abcdent:
													classified.mode === "print_web" &&
													isCurrentCategoryFree,
											})
									)
								}}
								€ <small>TTC</small>
							</td>
						</tr>
						<tr
							v-if="
								durationDiscount(
									parseInt(classified.duration),
									classified,
									true
								)
							"
						>
							<td>
								<strong> Prix après remise </strong>
							</td>
							<td>
								{{
									numberFormat(
										getPrice(classified, {
											only_options: true,
											no_medias: true,
											with_membership_discount: false,
											include_diff_abcdent:
												classified.mode === "print_web" &&
												isCurrentCategoryFree,
										})
									)
								}}
								€ <small>TTC</small>
							</td>
						</tr>
					</table>
				</div>
				<!-- pa-block__sidebar -->
			</div>
			<!-- .pa-block__inner -->
		</div>
		<!-- .pa-block -->
	</div>
	<!-- .options-selector -->
</template>
<script>
import { mapGetters, mapState } from "vuex";

export default {
	name: "options-selector",
	computed: {
		...mapState(["classified", "settings"]),
		...mapGetters(["isCurrentCategoryFree"]),
		option_background: {
			get() {
				return this.classified.option_background;
			},
			set(option) {},
		},
		option_urgent: {
			get() {
				return this.classified.option_urgent;
			},
			set(option) {},
		},
		option_move_top: {
			get() {
				return this.classified.option_move_top;
			},
			set(option) {},
		},
		option_domiciliation: {
			get() {
				return this.classified.option_domiciliation;
			},
			set(option) {},
		},
		option_diff_abcdent: {
			get() {
				return this.classified.option_diff_abcdent;
			},
			set(option) {},
		},
		option_diff_abcdent_pro: {
			get() {
				return this.classified.option_diff_abcdent_pro;
			},
			set(option) {},
		},
	},
	methods: {
		updateOption(e) {
			this.$store.commit("setOption", {
				name: e.target.name,
				value: e.target.checked,
			});
		},
		price(option) {
			// return this.getPrice(this.classified, { only_option: option });
			return this.numberFormat(
				this.settings.options[this.classified.profil][option]
				//  *
				//   this.durationDiscount(
				//     parseInt(this.classified.duration),
				//     this.classified
				//   )
			);
		},
		period() {
			return this.classified.mode == "web" ? "mois" : "semaine";
		},
	},

	mounted() {
		if (this.classified.mode === "print_web") {
			if (classified.profil === "recruiter") {
				this.classified.option_diff_abcdent = "1";
			} else {
				this.classified.option_diff_abcdent_pro = "1";
			}
		}
	},
};
</script>

<style lang="scss" scoped>
label {
	display: block;
}
</style>
